import type { AppEnv } from '@hc-frontend/core-context';
import { getClientApplicationConfig } from '@hc-frontend/core-context';

const medicareComLinkRegex = /^(www\.)?medicare\.((stg|qa)\.)?healthcare\.com/;

export function isMedicareComLink(url: URL) {
  return medicareComLinkRegex.test(url.hostname);
}

const hostnameMap: Record<AppEnv, string> = {
  local: 'medicare.qa.healthcare.com',
  dev: 'medicare.stg.healthcare.com',
  qa: 'medicare.qa.healthcare.com',
  stg: 'medicare.stg.healthcare.com',
  prd: 'medicare.healthcare.com',
};

export function checkMedicareComLink(url: URL): string {
  const config = getClientApplicationConfig();

  url.hostname = hostnameMap[config.core.appEnvironment];
  return decodeURIComponent(url.href);
}
